export default __webpack_public_path__ + "static/media/canvas-logo-full-white.cec8c541.svg";